var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.classes,attrs:{"color":"#FFFFFF","elevation":"0","tile":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }